/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from 'react';

import Fade from 'react-reveal/Fade';
import Header from 'parts/Header';
import HeroPortfolio from 'parts/HeroPortfolio';
import Discuss from 'parts/Discuss';
import Footer from 'parts/Footer';
import AllPortfolio from 'parts/AllPortfolio';

import Data from 'json/landingPage.json';

export default class ProjectPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Header {...this.props} />
        <section className="pt-32 pb-16 bg-gradient-to-b from-white to-gray-50">
          <div className="container mx-auto px-4">
            <Fade bottom>
              <h1 className="text-5xl lg:text-6xl text-theme-blue text-center font-bold mb-4">
                Case Studies
              </h1>
              <h2 className="text-3xl lg:text-4xl text-theme-blue text-center font-semibold mb-4">
                Case Studies
              </h2>
              <p className="font-light text-lg lg:text-xl text-gray-600 text-center mb-12 max-w-3xl mx-auto">
                Explore how we have helped businesses and industries with our intelligent
                software solutions.
              </p>
            </Fade>
          </div>
        </section>
        <HeroPortfolio {...this.props} />
        <AllPortfolio data={Data.portfolio} />
        <Discuss {...this.props} />
        <Footer />
      </>
    );
  }
}
